import { ApiError } from "../api/client.js";
import type { ReactNode } from "react";

export function PageState({
  query,
  children,
}: {
  query: { isPending: boolean; error: unknown; data?: unknown };
  children: ReactNode;
}) {
  if (query.isPending)
    return (
      <p className="loading" role="status">
        Getting things ready…
      </p>
    );
  if (query.error) {
    const e = query.error;
    const msg = e instanceof ApiError ? `${e.code}: ${e.message}` : String(e);
    return <p className="notice danger">{msg}</p>;
  }
  return <>{children}</>;
}

export function Empty({ label }: { label: string }) {
  return <div className="empty">{label}</div>;
}
